import { Box, Button, List } from "@mui/material";
import React, { useState } from "react";
import styles from "../../styles/pages/home.module.scss";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import usePagination from "@mui/material/usePagination";

// interface SearchEditorCardProps {
//   lastpage ;
//   onClick ;
//   sendDataToParent ;
//   fullitem:any
// }

export default function Pagination({ sendDataToParent, page, lastpage }) {
  // console.warn(props, "pagination")

  // props.lastpage
  const { items } = usePagination({ count: lastpage, page });

  const handlePagination = (item, pageNo, event) => {
    item?.onClick(event, pageNo);
    sendDataToParent(pageNo);
  };

  // console.warn(page,'page__')

  return lastpage > 1 ? (
    <Box className={`${styles.pagination} styledPagination`}>
      <List>
        {items.map(({ page, type, selected, ...item }, index) => {
          let children = null;

          if (type === "start-ellipsis" || type === "end-ellipsis") {
            children = "…";
          } else if (type === "page") {
            children = (
              <button type="button" {...item}>
                {page}
              </button>
            );
          } else {
            children = (
              <Button
                type="button"
                {...item}
                className={styles.btn_bar}
                startIcon={type == "previous" ? <ArrowBackIosIcon /> : null}
                endIcon={type == "previous" ? null : <ArrowForwardIosIcon />}
              >
                {type == "previous" ? "prev" : "next"}
              </Button>
            );
          }

          return (
            <li
              key={index}
              // className={`${selected ? "selected" : ""} ${
              //   item.disabled ? "disabled" : ""
              // }`}
              className={`${selected ? "selected" : ""} ${
                item.disabled ? "disabled" : ""
              }`}
              // {...item}
              onClick={(event) => handlePagination(item, page, event)}
            >
              {children}
            </li>
          );
        })}
      </List>
    </Box>
  ) : null;
}
